import { ISummaryTranslation } from "../../core/model/translations/SummaryTranslation";
import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";
import { IAttachment } from "../../caseLawDocuments/model/Attachment";

export interface TLegalView {
  id: number;
  name: string;
  status: string;
  summary: string;
  note: string;
  legalViewDate: Date;
  documentTypeId: number;
  organisationId: number;
  valid: boolean;
  summaryTranslations: ISummaryTranslation[];
  invalidatedBy: number;
  attachment?: IAttachment;
}

export interface ILegalView extends TLegalView {}

const LegalView = Model((model: TLegalView): ILegalView => {
  const _value: TLegalView = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get name() {
      return _value.name;
    },
    set name(value) {
      _value.name = value;
    },
    get status() {
      return _value.status;
    },
    set status(value) {
      _value.status = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    },
    get documentTypeId() {
      return _value.documentTypeId;
    },
    set documentTypeId(value) {
      _value.documentTypeId = value;
    },
    get organisationId() {
      return _value.organisationId;
    },
    set organisationId(value) {
      _value.organisationId = value;
    },
    get summary() {
      return _value.summary;
    },
    set summary(value) {
      _value.summary = value;
    },
    get note() {
      return _value.note;
    },
    set note(value) {
      _value.note = value;
    },
    get summaryTranslations() {
      return _value.summaryTranslations;
    },
    set summaryTranslations(value) {
      _value.summaryTranslations = value;
    },
    get invalidatedBy() {
      return _value.invalidatedBy;
    },
    set invalidatedBy(value) {
      _value.invalidatedBy = value;
    },
    get attachment() {
      return _value.attachment;
    },
    set attachment(value) {
      _value.attachment = value;
    },
    get legalViewDate() {
      return _value.legalViewDate;
    },
    set legalViewDate(value) {
      _value.legalViewDate = value;
    }
  };

  return ValidatableObject<ILegalView>(_model);
});

export default LegalView;
